import { SvgIcon } from "@mui/material"
import React from "react"

interface IProps {
  sx?: any
}

export function IconParcelleProject(props: Readonly<IProps>): React.JSX.Element {
  const { sx } = props

  return (
    <SvgIcon
      {...props}
      xmlns="https://fonts.google.com/"
      strokeWidth={2}
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
      stroke="currentColor"
      sx={{
        width: sx?.width ? sx?.width : "24",
        height: sx?.height ? sx?.height : "24",
      }}>
      <path
        d="M80-80h800L640-400l-200-80-120-160H80v560Z
        m80-80v-64l80 26 361-120 119 158H160Zm80-122-80-27v
        -75l80 26 158-52 96 43-254 85Zm500-118 180-80v-160l
        -180-40-100 80v120l100 80Zm-500-42-80-27v-91h120l65
         83-105 35Zm512-51-32-25v-44l40-32 80 18v44l-88 39Z
         M480-640l200-80v-200l-200-40-120 80v160l120 80Zm9-90-49-33v-74l57-38 103 21v80l-111 44Z"
      />
    </SvgIcon>
  )
}
